import { z } from 'zod';
import { IdSchema, DateTimeSchema, PaginationParamsSchema, HttpOrInternalFileUrlSchema, } from '../../common';
export const ParentSchema = z.object({
    id: IdSchema,
    email: z.string().email(),
    name: z.string(),
    phone: z.string().nullable(),
    city: z.string().nullable(),
    avatar: HttpOrInternalFileUrlSchema.nullable(),
    emailVerified: z.boolean(),
    createdAt: DateTimeSchema,
    profileId: IdSchema,
    occupation: z.string().nullable(),
    // Bağlı olduğu öğrenciler (özet — tam profil değil, sadece liste)
    students: z.array(z.object({
        studentUserId: IdSchema,
        name: z.string(),
        relationship: z.string().nullable(),
        isPrimary: z.boolean(),
    })),
});
export const CreateParentSchema = z.object({
    email: z.string().email(),
    password: z.string().min(8).regex(/[A-Z]/).regex(/[a-z]/).regex(/[0-9]/),
    name: z.string().min(2).max(120),
    phone: z.string().min(7).max(20),
    city: z.string().max(80).optional(),
    occupation: z.string().max(120).optional(),
});
export const UpdateParentSchema = z.object({
    name: z.string().min(2).max(120).optional(),
    phone: z.string().min(7).max(20).optional(),
    city: z.string().max(80).optional(),
    occupation: z.string().max(120).nullable().optional(),
});
export const ParentQuerySchema = PaginationParamsSchema.extend({
    search: z.string().optional(),
});
//# sourceMappingURL=parent.js.map